export default __webpack_public_path__ + "static/media/marker.15e7ee75.svg";